import { useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    createPreApproval,
    getVmsSettings,
} from '../../../../redux/actions/SocietyPortal/VmsAction/VmsAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import { notify } from '../../../../utils/notification';
import { SOCIETY_PORTAL, SOCIETY_PORTAL_PRE_APPROVALS } from '../../../../Routing/routes';
import PreApprovalForm from './PreApprovalForm';

const AddPreApproval = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();

    const saving = useSelector(state => state.VmsReducer?.preApprovals?.saving);
    const settings = useSelector(state => state.VmsReducer?.settings?.data);

    // max_pre_approval_days is stored but never read by the backend, so the cap
    // only exists if the form applies it. Settings are fetched purely for that.
    useEffect(() => {
        if (societyId && !settings) dispatch(getVmsSettings({ societyId }));
    }, [dispatch, societyId, settings]);

    const backToList = () => navigate(SOCIETY_PORTAL + SOCIETY_PORTAL_PRE_APPROVALS);

    const handleSubmit = (payload) => {
        if (!societyId) {
            notify('error', 'No society selected. Pick a society before creating a pre-approval.');
            return;
        }
        dispatch(createPreApproval({ ...payload, onSuccess: backToList }));
    };

    return (
        <div className="tw-p-5 tw-bg-gradient-to-br tw-from-gray-50 tw-to-slate-50 tw-min-h-screen">
            <div className="tw-w-full">
                <button
                    onClick={backToList}
                    className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-600 hover:tw-text-gray-800 tw-mb-3"
                >
                    <Icon icon="mdi:arrow-left" /> Back to Pre-approvals
                </button>

                <div className="tw-bg-white tw-rounded-xl tw-border tw-border-gray-100 tw-shadow-sm">
                    <div className="tw-p-4 tw-border-b tw-border-gray-100">
                        <h1 className="tw-mb-0 tw-text-base tw-font-bold tw-text-gray-800">New Pre-approval</h1>
                        <p className="tw-mb-0 tw-text-[11px] tw-text-gray-500 tw-mt-0.5">
                            Let an expected visitor through without calling the resident
                        </p>
                    </div>
                    <div className="tw-p-5">
                        <PreApprovalForm
                            mode="create"
                            societyId={societyId}
                            submitting={saving}
                            maxDays={settings?.max_pre_approval_days}
                            onSubmit={handleSubmit}
                            onCancel={backToList}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPreApproval;
